import React from 'react';
import { Check, X } from 'lucide-react';
import { MDP_REGLES } from '../utils/motDePasse';

// Liste des règles de mot de passe, cochées au fil de la saisie.
export default function ReglesMotDePasse({ password = '' }) {
  return (
    <ul className="mt-1.5 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-0.5">
      {MDP_REGLES.map(r => {
        const ok = r.test(password);
        return (
          <li key={r.key} className={`flex items-center gap-1.5 text-[12px] ${ok ? 'text-emerald-600' : 'text-navy-400'}`}>
            {ok ? <Check size={12} /> : <X size={12} />} {r.label}
          </li>
        );
      })}
    </ul>
  );
}
